import Lottie from 'lottie-react'
import moreToComeAnimation from '@/assets/lottie/more-to-come.json'

type LoggingOutOverlayProps = {
  open: boolean
}

export function LoggingOutOverlay({ open }: LoggingOutOverlayProps) {
  if (!open) return null

  return (
    <div className="!fixed !inset-0 !z-[100] !flex !items-center !justify-center !bg-black/40 !backdrop-blur-md !pointer-events-auto">
      <div className="!mx-4 !w-full !max-w-md !rounded-2xl !bg-white !px-6 !py-8 !text-center !shadow-[0px_0px_40px_rgba(0,0,0,0.2)]">
        <div className="!mx-auto !w-[180px] sm:!w-[220px]">
          <Lottie animationData={moreToComeAnimation} loop autoplay />
        </div>
        <p className="!mt-2 !text-lg !font-semibold !text-slate-900">
          Logging you out
        </p>
      </div>
    </div>
  )
}
